import React from 'react'
import UbiquaTowerToastAlert from '../../components/alerts/UbiquaTowerToastAlert'
import TowerUbiquaDetailHeader from '../../components/title/TowerUbiquaDetailHeader'

export default function RbacUserDetailHeader({
  title,
  backLabel,
  actionAlert,
  onBack,
  onCloseAlert
}) {
  return (
    <TowerUbiquaDetailHeader title={title} backLabel={backLabel} onBack={onBack}>
      <UbiquaTowerToastAlert
        open={Boolean(actionAlert)}
        id={actionAlert?.id}
        severity={actionAlert?.severity}
        title={actionAlert?.title}
        message={actionAlert?.message}
        onClose={onCloseAlert}
      />
    </TowerUbiquaDetailHeader>
  )
}
